import { defaultRound } from './round.js';
/**
 * True if any argument is NaN. Ported from `business-rules/common/common-rate.ts`.
 * Note: mirrors the original's `Number.isNaN` semantics on already-numeric inputs.
 */
export function isAnyNan(...args) {
  return args.some(value => Number.isNaN(value));
}
/**
 * True if `min` is strictly greater than `max` after both are rounded to the field's precision.
 * Ported from `business-rules/common/common-rate.ts` `isMinGreater`; the column-format lookup is
 * supplied by the injected {@link RoundFn} (defaults to 2-decimal rounding).
 */
export function isMinGreater(min, max, round = defaultRound) {
  return round(min) > round(max);
}
/**
 * `a + b` treating null/undefined as 0. Used by availability/property total aggregations.
 */
export function addition(a, b) {
  return (a ?? 0) + (b ?? 0);
}
/**
 * `(part / whole) * 100`. Consolidates the occupancy / vacancy / availability percentage math
 * (e.g. summary-info). No divide-by-zero guard — matches the source (whole=0 → Infinity/NaN, as before).
 */
export function percentageOf(part, whole) {
  return part / whole * 100;
}
/**
 * Raw `a / b` — the primitive behind the sale price-per-area relations (price-per-sqft,
 * sale-price-per-area, current-rent-per-area). Matches the host `valueModifierByDivide` exactly:
 * NO null/zero guard (callers gate non-null first; b=0 → Infinity, as before). The UK-currency/area
 * gating and GBP/EUR result-UOM assignment stay host-side.
 */
export function divide(a, b) {
  return a / b;
}
/** Raw `a * b` — the primitive behind sale price / current-rent from per-area (host `valueModifierByMultiple`). */
export function multiply(a, b) {
  return a * b;
}
